import { Controller } from 'react-hook-form';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { Label, Input } from '@/shared/components';

interface Props<TInput extends FieldValues, TOutput extends FieldValues> {
    control: Control<TInput, unknown, TOutput>;
    derivativeSelected: boolean;
    busy: boolean;
}

export const PlanVehicleRuleEngineFields = <TInput extends FieldValues, TOutput extends FieldValues>({
    control,
    derivativeSelected,
    busy,
}: Props<TInput, TOutput>) => (
    <>
        <div className="grid grid-cols-2 gap-3">
            <div>
                <Label htmlFor="pvr_engine_min">
                    Engine min (cc) <span className="text-mp-muted">(optional)</span>
                </Label>
                <Controller
                    name={'engine_min' as Path<TInput>}
                    control={control}
                    render={({ field, fieldState: { error: fieldError } }) => (
                        <Input
                            id="pvr_engine_min"
                            type="number"
                            min="0"
                            placeholder="Any"
                            disabled={busy || derivativeSelected}
                            value={(field.value as string | number | undefined) ?? ''}
                            onChange={(e) => field.onChange(e.target.value)}
                            onBlur={field.onBlur}
                            error={!!fieldError}
                            hint={fieldError?.message}
                        />
                    )}
                />
            </div>

            <div>
                <Label htmlFor="pvr_engine_max">
                    Engine max (cc) <span className="text-mp-muted">(optional)</span>
                </Label>
                <Controller
                    name={'engine_max' as Path<TInput>}
                    control={control}
                    render={({ field, fieldState: { error: fieldError } }) => (
                        <Input
                            id="pvr_engine_max"
                            type="number"
                            min="0"
                            placeholder="Any"
                            disabled={busy || derivativeSelected}
                            value={(field.value as string | number | undefined) ?? ''}
                            onChange={(e) => field.onChange(e.target.value)}
                            onBlur={field.onBlur}
                            error={!!fieldError}
                            hint={fieldError?.message}
                        />
                    )}
                />
            </div>
        </div>
        <p className="text-xs text-mp-warning">
            Engine-range rules apply to make/model-level rules. A vehicle with no recorded engine
            size will not match an engine-ranged rule.
        </p>
    </>
);
